import React from 'react';
import { Lightbulb, Navigation, Brain, Eye, Award, Heart } from 'lucide-react';

const ExperienceSection = () => {
  const principles = [
    { icon: <Navigation className="w-5 h-5" />, text: "Understanding traffic lights" },
    { icon: <Brain className="w-5 h-5" />, text: "Approaching junctions" },
    { icon: <Lightbulb className="w-5 h-5" />, text: "Making decisions" },
    { icon: <Eye className="w-5 h-5" />, text: "Building awareness" },
    { icon: <Award className="w-5 h-5" />, text: "Developing responsibility" }
  ];

  return (
    <section className="py-16 sm:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <img
                src="/kyle-drive-logo.png"
                alt="Kyle Drive"
                className="h-16 w-auto animate-pulse"
                style={{ animationDuration: '3s' }}
              />
              <div className="inline-block px-4 py-2 bg-gradient-to-r from-teal-500 to-cyan-500 text-white rounded-full text-sm font-semibold">
                Learning Through Experience
              </div>
            </div>
            
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[hsl(210,100%,20%)]">
              Children Remember <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-teal-500">Experiences</span><br />
              Not Lectures
            </h2>
            
            <p className="text-lg text-gray-700">
              Kyle Drive focuses on <strong>practical learning through real situations</strong>. Every lesson gives young learners hands-on experience in a safe, controlled environment.
            </p>

            <div className="space-y-3">
              {principles.map((principle, index) => (
                <div key={index} className="flex items-center space-x-3 bg-gradient-to-r from-cyan-50 to-teal-50 p-3 rounded-lg">
                  <div className="flex-shrink-0 w-10 h-10 bg-gradient-to-br from-cyan-500 to-teal-500 rounded-full flex items-center justify-center text-white">
                    {principle.icon}
                  </div>
                  <span className="text-[hsl(210,100%,20%)] font-medium">{principle.text}</span>
                </div>
              ))}
            </div>

            <div className="bg-gradient-to-r from-teal-500 to-cyan-500 rounded-2xl p-6 text-white">
              <div className="flex items-start space-x-3">
                <Heart className="w-6 h-6 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-semibold text-lg mb-2">Every Lesson Is:</p>
                  <div className="flex flex-wrap gap-2">
                    <span className="px-3 py-1 bg-white/20 rounded-full text-sm font-medium">Calm</span>
                    <span className="px-3 py-1 bg-white/20 rounded-full text-sm font-medium">Positive</span>
                    <span className="px-3 py-1 bg-white/20 rounded-full text-sm font-medium">Encouraging</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/clean-panels/panel-12.jpg"
                alt="Instructor teaching young learners practical driving concepts"
                className="w-full h-[500px] object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-cyan-600/90 via-cyan-600/60 to-transparent p-6">
                <p className="text-white text-xl font-bold">
                  Real-world skills. Real confidence. Real results.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExperienceSection;
